var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.99954 0.189186C10.7616 0.189186 13.8106 3.2384 13.8106 6.99973C13.8106 10.7609 10.7616 13.8108 6.99954 13.8108C3.23853 13.8108 0.188965 10.7609 0.188965 6.99973C0.188965 3.2384 3.23853 0.189186 6.99954 0.189186ZM6.9843 1.42553C3.88348 1.42553 1.36898 3.93937 1.36898 7.04046C1.36898 10.1421 3.88348 12.656 6.9843 12.656C10.0863 12.656 12.5996 10.1421 12.5996 7.04046C12.5996 3.93937 10.0863 1.42553 6.9843 1.42553ZM6.29159 3.41532C6.29159 2.52828 7.66606 2.52828 7.66606 3.41532V6.06537C8.05313 5.6832 8.43944 5.29978 8.82706 4.91751C9.45823 4.29407 10.4305 5.26578 9.79785 5.88856C9.02054 6.65834 8.24177 7.42682 7.4637 8.19606C7.46228 8.19807 7.4595 8.19943 7.45743 8.2008C7.44975 8.20782 7.44283 8.21327 7.43531 8.21959C7.21263 8.42005 6.95392 8.43247 6.73685 8.33603C6.50654 8.26051 6.32139 8.07177 6.29785 7.77368C6.29295 7.74039 6.29088 7.7071 6.29159 7.67304V3.41532Z",
    fill: "#666666"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.804d503c39a6afcbb1d6b06d95aeb0b0.svg";
export { ForwardRef as ReactComponent };